import {Component, ElementRef, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ConfService} from '../conf.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatSnackBar} from '@angular/material';
import {map, startWith} from 'rxjs/operators';
import {AttributeDescriptionComponent, CrudapiComponent, EntityVersions, ICategory, MethodTypes} from '../crudapi/crudapi.component';
import {Location} from '@angular/common';
import {ConnecttocrudService} from '../connecttocrud.service';
import {AppComponent} from '../app.component';
import {SecureApiConfirmationComponent} from '../manage-entities/manage-entities.component';
import {KongService} from '../kong.service';
import {ListenerService} from '../listener.service';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {DataaccessListenerService} from '../dataaccess-listener.service';

export interface User {
    display: string;
}

declare let $;
const incr = 5;

@Component({
    selector: 'app-edit-entity',
    templateUrl: './edit-entity.component.html',
    styleUrls: ['./edit-entity.component.css']
})
export class EditEntityComponent implements OnInit, OnDestroy {
    content = false;
    myControl = new FormControl();
    entityName: string;
    displayName: string;
    description: string;
    required: boolean;
    progress = 0;
    Blocks = [];
    destroy: any;
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    progressMessage: string;
    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    cloneOptions = [{'displayName': 'Clone API as defined above (No Data will be imported)', 'value': 'clone'},
        {'displayName': 'Clone API with Data Imported (No change in original schema)', 'value': 'cloneWithData'}];
    cloneOptionSelected = 'clone';
    ispublished = false;
    @Input() databases: any;
    datatypes: any;
    @Input() dataTypeFilter: any;
    selectDatatype: string;
    selectedDatatypeFilter: string;
    attributeName: string;
    attributetd: any;
    loading = false;
    trs: any;
    checkData: any;
    selectedDatatype = 'none';
    save: boolean;
    @Input() items: any;
    @Input() showBreadcrumb = true;
    flag: any;
    flagValue = true;
    cloneEnable: boolean;
    filteredOptions: Observable<ICategory[]>;
    options: any;
    cloneSave: boolean;
    url = environment.apihost;
    gatewayUrl: any;
    //= (this.partner === this.account ? 'https://gateway.' + this.partner + '.apiplatform.io' : 'https://gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    attributes = ['None', 'Primary', 'Unique'];
    type = ['none', 'change', 'rename', 'drop'];
    datastoragepolicy = ['None', 'Encrypted'];
    apiaccesspolicy = ['None', 'Decrypted', 'Encrypted', 'Masked (All with X)', 'Masked (All with x)', 'Masked (All with *)', 'Masked (xxxx-xxxx-xxxx-####)', 'Masked (xxxxxxxxxxxx####)'];
    displaypolicy = ['None', 'Decrypted', 'Encrypted', 'Masked'];
    data = ['String',
        'Integer',
        'Date',
        'Double',
        'Timestamp',
        'Boolean',
        'Array',
        'Object',
        'ObjectId'
    ];
    account = new FormControl();
    entityVersions: EntityVersions[] = [
        {name: 'v1'},
        {name: 'v2'},
        {name: 'v3'},
        {name: 'v4'}
    ];
    methodType =  [];
    methodTypes: MethodTypes[] = [
        {id: 'GET', itemName: 'GET'},
        {id: 'PUT', itemName: 'PUT'},
        {id: 'POST', itemName: 'POST'},
        {id: 'DELETE', itemName: 'DELETE'},
        {id: 'PATCH', itemName: 'PATCH'}
    ];
    selectGateway = 'default';
    gateways = [
        {gateway_name: 'default',
            gateway_type: 'apiplatform'
        }
    ];
    settings = {
        text: 'Select Method Types',
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    @Input() accounts = ['default'];
    @Input() partner: any;
    @Input() entity: string;
    @Input() version: string;
    tableName: string;
    tableLabelName = 'Table Name';
    showNextPanel = false;
    SaveEntityCheck: boolean;
    routerLink: any;
    APILoading = false;
    buttonClick = false;
    accept = false;
    changeFlag: any;
    partnerKey = localStorage.getItem('partnerKey');
    account_id = localStorage.getItem('account');
    apiKey = localStorage.getItem('apikey');
    @Input() apiByDefinition: any;
    // entities: any;
    // entityTypes = [];
    @Input() showSaveButton = true;
    entityAndVersion: any;

    origEntity: string;
    origVersion: string;
    origCollection: string;
    origMethods = [];
    previouslyDeployedData: any;
    previousSavedData: any;
    partnerEntities: any;
    partnerExecutors: any;
    isAPIAlreadyPresent: boolean;
    componentLoading = true;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;


    constructor(private location: Location,
                public dialog: MatDialog,
                private router: Router,
                private confPost: ConfService,
                private _service: ConnecttocrudService,
                private route: ActivatedRoute,
                private appComp: AppComponent,
                private elementRef: ElementRef,
                private leftPanelDataListener: ListenerService,
                public platform: LeftpanelComponent,
                private dataAccessListenerInstance: DataaccessListenerService,
                private kongService: KongService) {
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.appComp.currentPageTitle = 'Edit Data Access API';
        // this.gatewayUrl = (localStorage.getItem('partner') === localStorage.getItem('account') ? 'https://gateway.' + localStorage.getItem('partner') + '.apiplatform.io' : 'https://gateway.' + localStorage.getItem('account') + '.' + localStorage.getItem('partner') + '.apiplatform.io');
        this.gatewayUrl = (localStorage.getItem('partner') === localStorage.getItem('account') ? 'https://' + localStorage.getItem('partner') + '.gateway.apiplatform.io' : 'https://' + localStorage.getItem('partner') + '.' + localStorage.getItem('account') + '.' + 'gateway.apiplatform.io');
        // if (!this.databases) {}
        // this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
        //     this.databases = data;
        // });
        // this.progressMessage = 'Setting up your Account';
        this.router.events.subscribe((val) => {
            if (this.location.path() !== '') {
                this.routerLink = this.location.path();
                if (this.routerLink.includes('/entity/edit?partner=templates') || this.routerLink.includes('/entity/edit?partner=commons')) {
                    this.SaveEntityCheck = false;
                } else {
                    this.SaveEntityCheck = true;
                }
            }
        });

        // this.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'));
        // await this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     this.options = data;
        //     this.filteredOptions = this.myControl.valueChanges
        //         .pipe(
        //             startWith<string | ICategory>(''),
        //             map(value => typeof value === 'string' ? value : value.name),
        //             map(name => name ? this._filter(name) : this.options.slice())
        //         );
        // });

        // New Implementation but commented
        // if (this.platform.partnerCategories !== null && this.platform.partnerCategories !== undefined) {
        //     this.options = this.platform.partnerCategories;
        // } else {
        //     await this.platform.getCategoriesForPartnerAccount();
        //     this.options = this.platform.partnerCategories;
        // }
        // this.filteredOptions = this.myControl.valueChanges
        //     .pipe(
        //         startWith<string | ICategory>(''),
        //         map(value => typeof value === 'string' ? value : value.name),
        //         map(name => name ? this._filter(name) : this.options.slice())
        //     );


        // const getEntityNameAndVersionAsCustomType = new Promise(async (resolve, reject) => {
        //     if (this.platform.entityAndVersion !== null && this.platform.entityAndVersion !== undefined) {
        //         this.entityAndVersion = this.platform.entityAndVersion;
        //         resolve('success');
        //     } else {
        //         await this.confPost.getEntityNameAndVersionAsCustomType(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(response => {
        //                 if (response.status === 200) {
        //                     this.entityAndVersion = response.body['entityNameAndVersion'];
        //                     this.platform.entityAndVersion = this.entityAndVersion;
        //                     resolve('success');
        //                 } else {
        //                     resolve('failed');
        //                 }
        //             },
        //             error => {
        //                 this.platform.openSnackBar('Error while getting entity name and version for partner account: ' + error.error.message, 'Error', {
        //                     duration: 15000,
        //                     verticalPosition: 'top',
        //                     horizontalPosition: 'center'
        //                 });
        //                 resolve('failed');
        //             });
        //     }
        // });

        const getEntitiesForPartnerAccount = new Promise(async (resolve, reject) => {
            if (this.platform.partnerEntities !== null && this.platform.partnerEntities !== undefined) {
                this.partnerEntities = this.platform.partnerEntities;
                resolve('success');
            } else {
                await this.confPost.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data1 => {
                    if (data1 && data1 !== undefined && data1 !== null) {
                        this.partnerEntities = data1;
                        this.platform.partnerEntities = this.partnerEntities;
                        resolve('success');
                    } else {
                        resolve('failed');
                        this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
                            duration: 30000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }, error => {
                    resolve('failed');
                    this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        });

        const getApiExecutorsByPartnerAccount = new Promise((resolve, reject) => {
            if (this.platform.leftpanelData !== null && this.platform.leftpanelData !== undefined) {
                this.partnerExecutors = this.platform.leftpanelData;
                resolve('success');
            } else {
                this.confPost.getApiExecutorsByPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&fields=executor_name,executor_version,executor_method_type,executor_type,executor_scope,executor_display_name,executor_category,service_provider,apiUrl,published,scopeOfAccess,registeredAsIs,creationTime,lastModifiedTime,executor_description').toPromise().then(data => {
                    if (data && data !== null && data !== undefined) {
                        this.partnerExecutors = data;
                        this.platform.leftpanelData = data;
                        resolve('success');
                    } else {
                        resolve('failed');
                        this.platform.openSnackBar('Error while retrieving API executors for your account', 'Error', {
                            duration: 30000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }, error => {
                    resolve('failed');
                    this.platform.openSnackBar('Error while retrieving API executors for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        });

        // Promise.all([getEntityNameAndVersionAsCustomType]).then(resp => {
        //     this.componentLoading = false;
        // });

        this.route.queryParams
            .subscribe(params => {
                if (params.timestamp && params.timestamp !== null && params.timestamp !== undefined && params.timestamp !== '') {
                    this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + params.partner + '&account=' + params.account + '&at=' + params.timestamp).subscribe(response => {
                        if (response && response !== null && response !== undefined && response[0] && response[0]['executor']) {
                            this.apiByDefinition = response[0]['executor'];
                            this.checkData = JSON.parse(JSON.stringify(response[0]['executor']));
                            if (this.apiByDefinition.database !== 'default'){
                                for (let i = 0; i < this.apiByDefinition.attributes.length ; i++) {
                                    this.apiByDefinition.attributes[i]['updateOption'] = 'none';
                                }
                            }
                            this.items = response[0]['executor'];
                            if (this.items.methods && this.items.methods !== null && this.items.methods !== undefined && this.items.methods.length > 0) {
                                this.methodType = [];
                                this.items.methods.forEach(method => {
                                    this.methodType.push({'id': method, 'itemName': method});
                                });
                                // this.methodType = this.items.methods;
                                // this.origMethods = this.items.methods;
                            } else {
                                this.methodType = this.methodTypes;
                            }
                            this.origCollection = this.items['tableName'];
                            this.content = true;
                            this.ispublished = this.items['published'];
                            this.filterDataTypes(this.items.database);
                            if (this.partner === 'commons' || this.partner === 'templates') {
                                this.cloneEnable = true;
                            }
                        } else {
                            this.platform.openSnackBar('Error in retrieving the history for this API', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }, error => {
                        this.platform.openSnackBar('Error in retrieving the history for this API', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                } else {
                    this.partner = params.partner;
                    this.accounts = params.account;
                    this.entity = params.entity;
                    this.entityName = params.entity;
                    this.version = params.version;
                    this.origEntity = params.entity;
                    this.origVersion = params.version;
                    this.confPost.getEntity(params.partner, params.account, params.entity, params.version).subscribe(data => {
                        this.apiByDefinition = data;
                        this.previouslyDeployedData = {
                            'entityname': this.apiByDefinition['entityname'],
                            'category': this.apiByDefinition['category'],
                            'version': this.apiByDefinition['version'],
                            'displayname': this.apiByDefinition['displayname'],
                            'description': this.apiByDefinition['description'],
                            'scopeOfAccess': this.apiByDefinition['scopeOfAccess'],
                            'database': this.apiByDefinition['database'],
                            'methods': this.apiByDefinition['methods'],
                            'tableName': this.apiByDefinition['tableName'],
                            'published': this.apiByDefinition['published'],
                            'attributes': this.apiByDefinition.attributes
                        };
                        this.previouslyDeployedData = JSON.parse(JSON.stringify(this.previouslyDeployedData));
                        this.checkData = JSON.parse(JSON.stringify(data));
                        if (this.apiByDefinition.database !== 'default'){
                            for (let i = 0; i < this.apiByDefinition.attributes.length ; i++) {
                                this.apiByDefinition.attributes[i]['updateOption'] = 'none';
                            }
                        }
                        this.items = data;
                        if (this.items.methods && this.items.methods !== null && this.items.methods !== undefined && this.items.methods.length > 0) {
                            this.methodType = [];
                            this.items.methods.forEach(method => {
                                this.methodType.push({'id': method, 'itemName': method});
                            });
                            // this.methodType = this.items.methods;
                            // this.origMethods = this.items.methods;
                        } else {
                            this.methodType = this.methodTypes;
                        }
                        this.origCollection = this.items['tableName'];
                        this.content = true;
                        this.ispublished = this.items['published'];
                        this.filterDataTypes(this.items.database);
                        if (this.partner === 'commons' || this.partner === 'templates') {
                            this.cloneEnable = true;
                        }
                    });
                }
            });

        $(document).on('click', '.removeAttribute', function () {
            if ($(this).parent('td').closest('tr').next('table').length) {
                $(this).parent('td').closest('tr').next('table').remove();
            }
            $(this).parent('td').closest('tr').remove();
        });
        this.componentLoading = false;
    }
    changeType(def, i) {
        if (def['updateOption'] === 'rename') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'rename';
                this.apiByDefinition.attributes[i]['previousAttributeName'] = def['attributeName'];
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'rename',
                    'required': false,
                    'subType': []
                };
                this.apiByDefinition.attributes[i]['previousAttributeName'] = this.apiByDefinition.attributes[i]['attributeName'];
            }
        } else if (def['updateOption'] === 'drop') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'drop';
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'drop',
                    'required': false,
                    'subType': []
                };
            }
        }
        else if (def['updateOption'] === 'none') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'none';
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'none',
                    'required': false,
                    'subType': []
                };
            }
        } else if (def['updateOption'] === 'change') {
            if (this.checkData.attributes[i]) {
                this.apiByDefinition.attributes[i] = JSON.parse(JSON.stringify(this.checkData.attributes[i]));
                this.apiByDefinition.attributes[i]['updateOption'] = 'change';
            } else {
                this.apiByDefinition.attributes[i] = {
                    'customType': false,
                    'apiAccessPolicy': 'None',
                    'attributeName': null,
                    'type': null,
                    'array': false,
                    'size': null,
                    'precision': null,
                    'autoIncrement': false,
                    'defaultValue': null,
                    'attributeType': 'None',
                    'dataStoragePolicy': 'None',
                    'description': null,
                    'displayName': null,
                    'displayPolicy': null,
                    'updateOption': 'change',
                    'required': false,
                    'subType': []
                };
            }
        }
    }
    typeCheck(definition, subType) {

        const entityAndVersionCheckString = definition.type,
            substring = '_';
        if (entityAndVersionCheckString.includes(substring)) {
            definition.customType = true;
            definition.attributeType = 'DBRef';
            definition.array = true;
        } else {
            definition.customType = false;
            definition.attributeType = 'None';
            definition.array = false;
        }

        if (this.items['database'] === 'default' || this.items['database'] === 'mongo') {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition, subType, this.items['database']);
            } else {
                this.removeAttributeField(definition.subType);
            }
        } else {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition, subType, this.items['database']);
            } else {
                this.removeAttributeField(definition.subType);
            }
        }
    }

    addAttributeField(parent, data, selectDB) {
        if (selectDB === 'mongodb' || selectDB === 'default') {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'array': false,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': []
            };
            if (data == null) {
                parent.subType = [];
                parent.subType.push(newField);
            } else {
                data.push(newField);
            }
        } else {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'updateOption': 'none',
                'subType': [],
            };
            if (data == null) {
                parent.subType = [];
                parent.subType.push(newField);
            } else {
                data.push(newField);
            }
        }
    }

    removeAttributeField(data) {
        for (var i = 0; i < data.length; i++) {
            data.splice(i, 1);
        }
    }

    removeAttribute(data, index) {
        data.splice(index, 1);
    }

    setPrimaryFlag(i, type) {
        if (type == 'Primary' && this.flagValue) {
            this.flag = i;
            this.flagValue = false;
        } else if (i == this.flag && !this.flagValue && type !== 'Primary') {
            this.flag = null;
            this.flagValue = true;
        }
        if (type === 'Primary') {
            this.apiByDefinition.attributes[i]['required'] = true;
        } else {
            this.apiByDefinition.attributes[i]['required'] = false;
        }
    }

    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }

    getRegion(val) {
        return this.platform.getRegion(val);
    }

    // getEntitiesForPartnerAccount(partner, account) {
    //     this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
    //         this.entities = data;
    //         this.entities.forEach(entity => {
    //             this.entityTypes.push(entity.entityname + '_' + entity.version);
    //         });
    //     });
    // }

    omit_special_char(event) {
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)

        // return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57));
        return(k !== 95);
    }

    async filterDataTypes(val) {
        if (this.apiByDefinition.database !== 'default'){
            for (let i = 0; i < this.apiByDefinition.attributes.length ; i++) {
                this.apiByDefinition.attributes[i]['updateOption'] = 'none';
            }
        }
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            this.databases = this.platform.databases;
            this.databases.filter(items => {
                if (items.database_name === val) {
                    this.selectedDatatypeFilter = items.database_type;
                }
            });
        } else {
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                    await this.platform.updateIsNoSQLForMongo(databases);
                    this.databases = this.platform.databases;
                    this.databases.filter(items => {
                        if (items.database_name === val) {
                            this.selectedDatatypeFilter = items.database_type;
                        }
                    });
                },
                error => {
                    this.platform.openSnackBar('Error while getting list of databases: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        }
        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
            this.dataTypeFilter = [];
            this.datatypes.filter(items => {
                if (items.database_type === this.selectedDatatypeFilter) {
                    this.dataTypeFilter.push(items);
                }
            });
            if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
                await this.platform.getCustomTypes(val);
                this.entityAndVersion = this.platform.entityAndVersion;
            } else {
                this.entityAndVersion = [];
            }
            if (this.entityAndVersion) {
                for (let i = 0; i < this.entityAndVersion.length; i++) {
                    const newType = {
                        'database_type': 'mongodb',
                        'data_types': [
                            {
                                'type': this.entityAndVersion[i],
                                'default_length': '',
                                'min_length': '',
                                'max_length': ''
                            }]
                    };
                    this.dataTypeFilter.push(newType);
                }
            }
            if (this.selectedDatatypeFilter === 'mongodb') {
                this.tableLabelName = 'Collection Name';
            } else {
                this.tableLabelName = 'Table Name';
            }
        } else {
            await this.confPost.getDataTypes().toPromise().then(async data => {
                    this.datatypes = data;
                    this.platform.datatypes = data;
                    this.dataTypeFilter = [];
                    this.datatypes.filter(items => {
                        if (items.database_type === this.selectedDatatypeFilter) {
                            this.dataTypeFilter.push(items);
                        }
                    });
                    if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
                        await this.platform.getCustomTypes(val);
                        this.entityAndVersion = this.platform.entityAndVersion;
                    } else {
                        this.entityAndVersion = [];
                    }
                    if (this.entityAndVersion) {
                        for (let i = 0; i < this.entityAndVersion.length; i++) {
                            const newType = {
                                'database_type': 'mongodb',
                                'data_types': [
                                    {
                                        'type': this.entityAndVersion[i],
                                        'default_length': '',
                                        'min_length': '',
                                        'max_length': ''
                                    }]
                            };
                            this.dataTypeFilter.push(newType);
                        }
                    }
                    if (this.selectedDatatypeFilter === 'mongodb') {
                        this.tableLabelName = 'Collection Name';
                    } else {
                        this.tableLabelName = 'Table Name';
                    }
                },
                error => {
                    this.platform.openSnackBar('Error while getting list of data types: ' + error.error.message, 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
        }

    }

    getDatabaseTypeForDatabaseName(val) {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
            }
        });
    }


    displayFn1(user?: User): string | undefined {
        return user ? user.display : undefined;
    }

    async createOrUpdateApi() {

        Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.items['entityname'])).then(resp1 => {
            if (resp1 === true) {
                Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.items['version'])).then(async resp2 => {
                    if (resp2 === true) {
                        const temparray = [];
                        for (let i = 0; i < this.apiByDefinition['attributes'].length; i++ ) {
                            if (this.apiByDefinition['attributes'][i]['attributeName'] !== null && this.apiByDefinition['attributes'][i]['type'] !== null) {
                                temparray.push(this.apiByDefinition['attributes'][i]);
                            }
                        }
                        this.apiByDefinition['attributes'] = temparray;
                        if (this.apiByDefinition['attributes'].length === 0) {
                            this.platform.openSnackBar('Please define schema under Schema Definition', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        } else {
                            if (this.origEntity === this.items['entityname'] && this.origVersion === this.items['version']) {
                                this.updateApi();
                            } else {
                                const publishdata = {};
                                var message = 'Change in entity';
                                publishdata['origEntity'] = this.origEntity;
                                publishdata['origVersion'] = this.origVersion;
                                publishdata['entity'] = this.items['entityname'];
                                publishdata['version'] = this.items['version'];
                                publishdata['tableName'] = this.items['tableName'];
                                publishdata['origCollection'] = this.origCollection;

                                if (this.origEntity !== this.items['entityname']) {
                                    if (this.origVersion !== this.items['version']) {
                                        message = 'Both the name and version of the entity have been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                                    } else {
                                        message = 'Name of the entity has been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                                    }
                                } else {
                                    if (this.origVersion !== this.items['version']) {
                                        message = 'Version of the entity has been changed. Hence this will create another entity : ' + this.items['entityname'] + ' with the version: ' + this.items['version'] + '. Do you want to continue creating a new Data Access Service ?';
                                    }
                                }
                                let entityLength = 0;
                                let versionLength = 0;
                                for (let i = 0; i < this.items['entityname'].length; i++) {
                                    if (this.items['entityname'].charCodeAt(i) === 8 || this.items['entityname'].charCodeAt(i) === 32 || (this.items['entityname'].charCodeAt(i) > 64 && this.items['entityname'].charCodeAt(i) < 91) || (this.items['entityname'].charCodeAt(i) > 96 && this.items['entityname'].charCodeAt(i) < 123) || (this.items['entityname'].charCodeAt(i) >= 48 && this.items['entityname'].charCodeAt(i) <= 57)) {
                                        entityLength++;
                                    }
                                }

                                for (let i = 0; i < this.items['version'].length; i++) {
                                    if (this.items['version'].charCodeAt(i) === 8 || this.items['version'].charCodeAt(i) === 32 || (this.items['version'].charCodeAt(i) > 64 && this.items['version'].charCodeAt(i) < 91) || (this.items['version'].charCodeAt(i) > 96 && this.items['version'].charCodeAt(i) < 123) || (this.items['version'].charCodeAt(i) >= 48 && this.items['version'].charCodeAt(i) <= 57)) {
                                        versionLength++;
                                    }
                                }
                                if (versionLength === this.items['version'].length && entityLength === this.items['entityname'].length) {
                                    publishdata['message'] = message;
                                    if (this.isAPIAlreadyPresentCheckCompleted === false) {
                                        await this.checkForExistingEntityAndExecutor();
                                    }

                                    if (this.isAPIAlreadyPresent === false) {
                                        const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                                            width: '60%',
                                            data: publishdata
                                        });

                                        dialogRef.afterClosed().subscribe(result => {
                                            if (result) {
                                                // Create API
                                                this.createApi();
                                                if (dialogRef.componentInstance.copyData) {
                                                    // Handle this
                                                } else {
                                                    // Handle this
                                                }
                                            }
                                        });
                                    } else {
                                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                } else {
                                    this.platform.openSnackBar('Special characters are not allowed in version and name.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }
                            }
                        }
                    } else {
                        this.loading = false;
                        this.platform.openSnackBar('Executor version should not have any special characters or spaces in between', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                });
            } else {
                this.loading = false;
                this.platform.openSnackBar('Executor name should not have any special characters or spaces in between', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        });
    }
    generateExecutorAgain() {
        window.location.reload();
    }

    updateApi() {
        const that = this;
        this.save = false;

        let entityLength = 0;
        let versionLength = 0;
        var methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        for (let i = 0; i < this.items['entityname'].length; i++) {
            if (this.items['entityname'].charCodeAt(i) === 8 || this.items['entityname'].charCodeAt(i) === 32 || (this.items['entityname'].charCodeAt(i) > 64 && this.items['entityname'].charCodeAt(i) < 91) || (this.items['entityname'].charCodeAt(i) > 96 && this.items['entityname'].charCodeAt(i) < 123) || (this.items['entityname'].charCodeAt(i) >= 48 && this.items['entityname'].charCodeAt(i) <= 57)) {
                entityLength++;
            }
        }

        for (let i = 0; i < this.version.length; i++) {
            if (this.items['version'].charCodeAt(i) === 8 || this.items['version'].charCodeAt(i) === 32 || (this.items['version'].charCodeAt(i) > 64 && this.items['version'].charCodeAt(i) < 91) || (this.items['version'].charCodeAt(i) > 96 && this.items['version'].charCodeAt(i) < 123) || (this.items['version'].charCodeAt(i) >= 48 && this.items['version'].charCodeAt(i) <= 57)) {
                versionLength++;
            }
        }

        if (entityLength === this.items['entityname'].length) {
            if (versionLength === this.items['version'].length) {
                this.loading = true;
                const crudAPI = {
                    'entityname': this.items['entityname'],
                    'category': this.items['category'],
                    'version': this.items['version'],
                    'displayname': this.items['displayname'],
                    'description': this.items['description'],
                    'scopeOfAccess': this.items['scopeOfAccess'],
                    'database': this.items['database'],
                    'methods': methods,
                    'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
                    'published': this.items['published'],
                    'attributes': this.apiByDefinition.attributes
                };

                const temp = JSON.parse(JSON.stringify(crudAPI));
                let isSame = true;
                if (this.previouslyDeployedData !== undefined && this.previouslyDeployedData !== null) {
                    if (Object.keys(this.previouslyDeployedData).length === Object.keys(temp).length){
                        const keyArray = Object.keys(this.previouslyDeployedData);
                        for (const key of keyArray) {
                            if (JSON.stringify(this.previouslyDeployedData[key]) === JSON.stringify(temp[key])) {
                                continue;
                            } else {
                                isSame = false;
                                break;
                            }
                        }
                    } else {
                        isSame = false;
                    }
                } else {
                    isSame = false;
                }

                if (isSame === false) {
                    this.confPost.updateEntity(this.partner, this.accounts, crudAPI).subscribe(data => {
                        this.previouslyDeployedData = JSON.parse(JSON.stringify(crudAPI));
                        if (this.items['published']) {
                            this.kongService.updateRouteWithMethods(this.partner, this.accounts, this.items['entityname'], this.items['version'], methods, Date.now(), '');
                            if (!this.ispublished) {
                                this.Blocks = [4, 5];
                                const blockLength = this.Blocks.length;
                                const blockStart = this.BlockList[this.Blocks[0]];
                                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                this.progress = blockStart;
                                this.save = true;
                                that.setInterval(blockEnd, true);
                                // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');

                            } else {
                                this.Blocks = [1, 2, 3, 4];
                                const blockLength = this.Blocks.length;
                                const blockStart = this.BlockList[this.Blocks[0]];
                                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                this.progress = blockStart;
                                this.save = true;
                                that.setInterval(blockEnd, true);
                                // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                            }
                        } else {
                            this.Blocks = [1, 2, 3];
                            this.save = true;
                            const blockLength = this.Blocks.length;
                            const blockStart = this.BlockList[this.Blocks[0]];
                            const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                            this.progress = blockStart;
                            that.setInterval(blockEnd, true);
                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                        }

                    }, error => {
                        this.loading = false;
                        let errorMessage = '';
                        if (error.error['message']) {
                            errorMessage = error.error.message;
                        } else {
                            const dialogRef = this.dialog.open(DialogComponent, {
                                data: {title: 'Error while Updating', message: error.error}
                            });
                            errorMessage = error.error;
                        }
                        this.platform.openSnackBar('Error while adding Entity', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    });
                } else {
                    this.loading = false;
                    this.platform.openSnackBar('There are no changes to redeploy this API.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    manageProgress(endBlock, showPanel) {
        // if (this.progress >= endBlock) {
        //     this.showNextPanel = showPanel;
        // this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //     let item = data;
        // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
        let apiKey = localStorage.getItem('apikey');
        const dialogRef = this.dialog.open(DialogComponent, {
            maxWidth: '95vw',
            data: {type: 'dataaccess', save: true, ispublished: this.ispublished, gatewayFullUrl: this.gatewayUrl, Blocks: this.Blocks, version: this.version, showNextPanel: false, partner: this.partner, account: this.account_id, entityName: this.entityName, apiKey: apiKey, partnerKey: this.partnerKey}
        });
        dialogRef.afterClosed().subscribe(async result => {
            if (result === 'create') {
                await this.router.navigateByUrl('/dataaccessapi');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else if (result === 'edit') {
                this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            } else if (result === 'data') {
                this.router.navigateByUrl('/api?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            } else if (result === 'devex') {
                this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            }
        });
        // });
        // });
        this.loading = false;
        this.ngOnDestroy();
        // } else {
        //     this.progress = this.progress + incr;
        // }
        // if (this.progress <= 35) {
        //     this.progressMessage = 'Setting Up API';
        // } else if (this.progress > 35 && this.progress <= 70) {
        //     this.progressMessage = 'Setting Up Database';
        //     /*} else if (this.progress > 70 && this.progress <= 98) {
        //         this.progressMessage = 'Creating dedicated File storage for your account';*/
        // } else if (this.progress > 70) {
        //     this.progressMessage = 'Deploying into Cloud';
        // }
    }

    navigateToData() {
        this.router.navigate(['/api'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('account'),
                    entity: $('#entityName').val(),
                    version: this.items['version']
                }
            });
    }

    getSubAttributes(that) {
        let subAttribute = [];
        const func = this;
        if ($(that).next('.sub-array').length) {
            $(that).next('.sub-array').children('.add-array').children('table').children('tbody').children('.root').each(function () {
                subAttribute.push({
                    'attributeName': $(this).find('td:first').find('input').val(),
                    'displayName': null,
                    'description': null,
                    'type': $(this).find('td:eq(1)').find('select').val(),
                    'attributeType': $(this).find('td:eq(2)').find('select').val(),
                    'required': $(this).find('td:eq(3)').find('input').prop('checked'),
                    'dataStoragePolicy': $(this).find('td:eq(4)').find('select').val(),
                    'apiAccessPolicy': $(this).find('td:eq(5)').find('select').val(),
                    'displayPolicy': null,
                    'subType': func.getSubAttributes($(this))
                });
            });
        } else {
            subAttribute = null;
        }
        return subAttribute;
    }

    cloneApi() {
        this.buttonClick = true;
        const that = this;
        const attribute = [];
        $('#attributeTable').children('tbody').children('.root').each(function () {
            if ($(this).find('input:first').val().trim() == '') {
                $(this).find('input:first').focus();
                return false;
            }
            attribute.push({
                'attributeName': $(this).find('td:first').find('input').val(),
                'displayName': null,
                'description': null,
                'type': $(this).find('td:eq(1)').find('select').val(),
                'attributeType': $(this).find('td:eq(2)').find('select').val(),
                'required': $(this).find('td:eq(3)').find('input').prop('checked'),
                'dataStoragePolicy': $(this).find('td:eq(4)').find('select').val(),
                'apiAccessPolicy': $(this).find('td:eq(5)').find('select').val(),
                'displayPolicy': null,
                'subType': that.getSubAttributes($(this))
            });
        });
        const crudAPI = {
            'entityname': $('#entityName').val(),
            'category': this.items['category'],
            'version': this.items['version'],
            'displayname': $('#displayName').val(),
            'description': $('#Entitydescription').val(),
            'scopeOfAccess': this.items['scopeOfAccess'],
            'database': this.items['database'],
            'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + $('#entityName').val() + '_' + this.items['version'],
            'attributes': attribute
        };
        const createDeleteAudit = [{
            'planName': localStorage.getItem('currentPlan'),
            'createdDate': Date.now(),
            'removedDate': null
        }];
        const auditAPI = {
            'partner': localStorage.getItem('partner'),
            'account_id': localStorage.getItem('account'),
            'entityname': $('#entityName').val(),
            'version': ((typeof this.version) == 'object' ? this.version['name'] : this.version),
            'status': 'active',
            'currentPlanName': localStorage.getItem('currentPlan'),
            'createDeleteAudit': createDeleteAudit
        };
        this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            this.platform.openSnackBar('The API has successfully been cloned successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.cloneSave = true;
            this.showNextPanel = true;

        }, error => {
            this.platform.openSnackBar('Error while cloning the API', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
        this._service.addAuditItem(auditAPI, 'v1', 'billing', 'billing', 'PartnerApiAudit').subscribe(
            status => {
            }, error => {
                this.platform.openSnackBar('Error while adding audit details for the Entity Creation', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        this.APILoading = true;
    }

    private _filter(name: string): ICategory[] {
        const filterValue = name.toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    CloneAPIwithOptions() {
        this.buttonClick = true;
        if (this.cloneOptionSelected === 'clone') {
            this.cloneApi();
        } else {
            this.CloneWithData();
        }
        this.cloneSave = true;
    }

    CloneWithData() {
        this.buttonClick = true;
        const APIUrl = environment.apihost + '/' + this.version + '/config/' + this.partner + '/' + this.accounts + '/' + this.entity;
        const dataroot = '';
        const Header = [];
        Header.push({
            'Content-Type': 'application/json'
        });
        Header.push({
            'pkey': '3fe18f9884ea832e3fede1e661740c4a'
        });
        const crudAPI = {
            'entityname': $('#entityName').val(),
            'category': this.items['category'],
            'version': this.items['version'],
            'displayname': $('#displayName').val(),
            'description': $('#Entitydescription').val(),
            'scopeOfAccess': this.items['scopeOfAccess'],
            'database': this.items['database'],
            'importData': true,
            'APIUrl': APIUrl,
            'dataroot': dataroot,
            'Header': Header
        };
        this.confPost.createAPI(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            this.platform.openSnackBar('API Created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.APILoading = true;


        }, error => {
            this.platform.openSnackBar(error.error.message, 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    navigateDataView() {
        this.router.navigate(['/api'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('partner'),
                    entity: $('#entityName').val(),
                    version: this.items['version']
                }
            });
    }

    navigateAPIReview() {
        this.router.navigate(['/entity/edit'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('partner'),
                    entity: $('#entityName').val(),
                    version: this.items['version']
                }
            });
    }

    openAttributeDescriptionDialog(definition) {
        const data = {
            'displayName': definition.displayName,
            'description': definition.description,
            'dataStoragePolicy': definition.dataStoragePolicy,
            'apiAccessPolicy': definition.apiAccessPolicy,
            'displayPolicy': definition.displayPolicy
        };
        const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
            definition.displayName = data.displayName;
            definition.description = data.description;
            definition.dataStoragePolicy = data.dataStoragePolicy;
            definition.apiAccessPolicy = data.apiAccessPolicy;
            definition.displayPolicy = data.displayPolicy;
        });
    }

    setPublish(value: boolean) {
        this.items['published'] = value;
    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    copyText(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(val).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        alert('CURL command copied to clipboard');
    }

    saveAPI() {

        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        const savePayload = {
            partner: '',
            account: '',
            executor_name: '',
            executor_type: '',
            by: '',
            executor_version: '',
            action: ''
        };

        savePayload.partner = this.partner;
        savePayload.account = this.account_id;
        savePayload['at'] = Date.now();
        savePayload.by = this.partner;

        if (this.items['entityname'] !== null && this.items['entityname'] !== undefined && this.items['entityname'] !== '') {
            savePayload.executor_name = this.items['entityname'];
        } else {
            savePayload.executor_name = Date.now().toString();
        }

        savePayload.executor_version = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
        savePayload.action = 'UPDATE';
        savePayload.executor_type = 'API';

        const crudAPI = {
            'entityname': this.items['entityname'],
            'category': this.items['category'],
            'version': this.items['version'],
            'displayname': this.items['displayname'],
            'description': this.items['description'],
            'scopeOfAccess': this.items['scopeOfAccess'],
            'database': this.items['database'],
            'methods': methods,
            'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
            'published': this.items['published'],
            'attributes': this.apiByDefinition.attributes
        };

        savePayload['executor'] = crudAPI;
        const temp = JSON.parse(JSON.stringify(savePayload['executor']));
        let isSame = true;
        if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
            if (Object.keys(this.previousSavedData).length === Object.keys(temp).length){
                const keyArray = Object.keys(this.previousSavedData);
                for (const key of keyArray) {
                    if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                        continue;
                    } else {
                        isSame = false;
                        break;
                    }
                }
            } else {
                isSame = false;
            }
        } else {
            isSame = false;
        }
        if (isSame === false) {
            this.confPost.saveExecutorInformation('v1', savePayload).subscribe(response => {
                this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
            }, error => {
                this.platform.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            this.platform.openSnackBar('No changes to save for this Data Access API.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }


    checkForExistingEntityAndExecutorFromFocusOut() {
        setTimeout(() => {
            this.checkForExistingEntityAndExecutor();
        }, 1000);
    }

    CheckForExistingEntityOrExecutor() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.items['entityname'], this.items['version'])).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = this.entityName;
                this.previouslyCheckedVersion = this.version;
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.items['entityname'];
                        this.previouslyCheckedVersion = this.items['version'];
                        resolve('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.items['entityname'];
                        this.previouslyCheckedVersion = this.items['version'];
                        resolve('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor() {
        return new Promise(async (resolve, reject) => {
            if (this.items['entityname'] !== null && this.items['entityname'] !== undefined && this.items['entityname'] !== '' && this.items['version'] !== null && this.items['version'] !== undefined && this.items['version'] !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.items['entityname'] !== this.origEntity || this.items['version'] !== this.origVersion) {
                            if (this.previouslyCheckedName !== this.items['entityname'] || this.previouslyCheckedVersion !== this.items['version']) {
                                this.isAPIAlreadyPresentCheckCompleted = true;
                                await this.CheckForExistingEntityOrExecutor();
                                resolve('success');
                            } else {
                                resolve('success');
                            }
                        } else {
                            resolve('success');
                        }
                    } else {
                        if (this.items['entityname'] !== this.origEntity || this.items['version'] !== this.origVersion) {
                            this.isAPIAlreadyPresentCheckCompleted = true;
                            await this.CheckForExistingEntityOrExecutor();
                            resolve('success');
                        } else {
                            resolve('success');
                        }
                    }
                } else {
                    resolve('success');
                }
            }
        });
    }

    async createApi() {

        this.save = false;
        const that = this;
        let entityLength = 0;
        let versionLength = 0;

        var methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        for (let i = 0; i < this.items['entityname'].length; i++) {
            if (this.items['entityname'].charCodeAt(i) === 8 || this.items['entityname'].charCodeAt(i) === 32 || ( this.items['entityname'].charCodeAt(i) > 64 && this.items['entityname'].charCodeAt(i) < 91) || ( this.items['entityname'].charCodeAt(i) > 96 && this.items['entityname'].charCodeAt(i) < 123) || ( this.items['entityname'].charCodeAt(i) >= 48 && this.items['entityname'].charCodeAt(i) <= 57)) {
                entityLength++;
            }
        }

        for (let i = 0; i < this.items['version'].length; i++) {
            if (this.items['version'].charCodeAt(i) === 8 || this.items['version'].charCodeAt(i) === 32 || ( this.items['version'].charCodeAt(i) > 64 && this.items['version'].charCodeAt(i) < 91) || ( this.items['version'].charCodeAt(i) > 96 && this.items['version'].charCodeAt(i) < 123) || ( this.items['version'].charCodeAt(i) >= 48 && this.items['version'].charCodeAt(i) <= 57)) {
                versionLength++;
            }
        }
        // if ((this.partnerEntities.filter(element => element.entityname === this.items['entityname'])).length === 0) {
        //         if ((this.partnerExecutors.filter(element => element.executor_name === this.items['entityname'])).length === 0) {
        //                 this.isAPIAlreadyPresent = false;
        //         } else {
        //             if ((this.partnerExecutors.filter(element => (element.executor_version === this.items['version'] && element.executor_name === this.items['entityname']))).length === 0) {
        //                 this.isAPIAlreadyPresent = false;
        //             } else {
        //                 this.isAPIAlreadyPresent = true;
        //             }
        //         }
        // } else {
        //     if ((this.partnerEntities.filter(element => (element.version === this.items['version'] && element.entityname === this.items['entityname']))).length === 0) {
        //         this.isAPIAlreadyPresent = false;
        //     } else {
        //         this.isAPIAlreadyPresent = true;
        //     }
        // }

        // if ((this.partnerEntities.filter(element => (element.entityname === this.items['entityname'] && element.version === this.items['version'])).length === 0)) {
        //     if ((this.partnerExecutors.filter(element => (element.executor_name === this.items['entityname'] && element.executor_version === this.items['version'])).length === 0)) {
        //         this.isAPIAlreadyPresent = false;
        //     } else {
        //         this.isAPIAlreadyPresent = true;
        //     }
        // } else {
        //     this.isAPIAlreadyPresent = true;
        // }

        if (this.isAPIAlreadyPresent === false) {
            if (entityLength === this.items['entityname'].length) {
                if (versionLength === this.items['version'].length) {
                    // if (!this.isSpecialCharacterInAttribute) {
                    this.loading = true;
                    const crudAPI = {
                        'entityname': this.items['entityname'],
                        'category': this.items['category'],
                        'version': this.items['version'],
                        'displayname': this.items['displayname'],
                        'description': this.items['description'],
                        'scopeOfAccess': this.items['scopeOfAccess'],
                        'database': this.items['database'],
                        'methods': methods,
                        'tableName': this.items['tableName'] !== null ? this.items['tableName'] : this.account_id + '_' + this.items['entityname'] + '_' + this.items['version'],
                        'published': this.items['published'],
                        'attributes': this.apiByDefinition.attributes
                    };
                    this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {

                        // Added the below two lines to get the latest entity details that's been created newly by either changing the entity name or version.
                        this.entityName = this.items['entityname'];
                        this.version = this.items['version'];
                        if (data && data['message'] === 'API already exists.') {
                            this.save = false;
                            this.loading = false;
                            this.platform.openSnackBar(data['message'], 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        } else {
                            if (this.ispublished) {
                                this.Blocks = [1, 2, 3, 4, 5];
                                const blockLength = this.Blocks.length;
                                const blockStart = this.BlockList[this.Blocks[0]];
                                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                this.progress = blockStart;
                                this.save = true;
                                that.setInterval(blockEnd, true);
                                // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
                                    // localStorage.setItem('dataAccessAPI' , JSON.stringify(data));
                                    this.platform.apiExecutors = data;
                                    // localStorage.setItem('isDataAccessAPISet', 'true');
                                    // localStorage.setItem('updatedDataAccessAPI', JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']}));
                                });
                            } else {
                                this.Blocks = [1, 2, 3];
                                this.save = true;
                                const blockLength = this.Blocks.length;
                                const blockStart = this.BlockList[this.Blocks[0]];
                                const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                this.progress = blockStart;
                                that.setInterval(blockEnd, false);
                                // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                            }
                            if (this.ispublished) {
                                // this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.items['entityname'], this.items['version'], false, false);
                                this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.items['entityname'], this.items['version'], false, false, methods, Date.now(), '');
                            }
                        }
                    }, error => {
                        this.save = false;
                        // this.ispublished = false;
                        this.loading = false;
                        let errorMessage = '';
                        if (error.error['message']) {
                            errorMessage = error.error.message;
                        } else {
                            const dialogRef = this.dialog.open(DialogComponent, {
                                data: {title: 'Error while updating', message: error.error}
                            });
                            errorMessage = error.error;
                        }
                        this.platform.openSnackBar('Error while adding Entity', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });

                    });
                    // if (this.ispublished) {
                    //     this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.items['entityname'], this.items['version'], false, false);
                    // }
                    // } else {
                    //     this.platform.openSnackBar('Special characters are not allowed in attribute name', 'Error', {
                    //         duration: 5000,
                    //         verticalPosition: 'top',
                    //         horizontalPosition: 'center'
                    //     });
                    // }
                } else {
                    this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }
}

@Component({
    selector: 'entity-version-change-confirmation',
    templateUrl: 'entity-version-change-confirmation.component.html',
    styleUrls: ['entity-version-change-confirmation.component.css']
})
export class EntityVersionChangeConfirmationComponent {
    copyData = false;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

}
